const COMPENSATION_ATTRIBUTE =
  'Reikalingi dokumentai kompensacijai';

const COMPENSATION_NOTE =
  'Reikalauja dokumentų kompensacijai.';

function removeCompensationNote(note = '') {
  return String(note)
    .split(/\r?\n/)
    .filter((line) => {
      const normalizedLine = line
        .trim()
        .replace(/\.$/, '')
        .toLocaleLowerCase('lt-LT');

      return (
        normalizedLine !==
        'reikalauja dokumentų kompensacijai'
      );
    })
    .join('\n')
    .trim();
}

if (!customElements.get('cart-compensation-documents')) {
  class CartCompensationDocuments extends HTMLElement {
    constructor() {
      super();
      this.handleChange = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.checkbox = this.querySelector(
        '[data-compensation-checkbox]'
      );

      this.checkbox?.addEventListener(
        'change',
        this.handleChange
      );
    }

    disconnectedCallback() {
      this.checkbox?.removeEventListener(
        'change',
        this.handleChange
      );
    }

    setBusy(isBusy) {
      document
        .querySelectorAll('[data-compensation-checkbox]')
        .forEach((checkbox) => {
          checkbox.disabled = isBusy;
        });

      document
        .querySelectorAll(
          '.mini-cart-footer-actions, .cart-ctas, .cart-dynamic-checkout-buttons'
        )
        .forEach((checkoutArea) => {
          if (isBusy) {
            checkoutArea.dataset.compensationWasInert =
              checkoutArea.hasAttribute('inert')
                ? 'true'
                : 'false';

            checkoutArea.setAttribute('inert', '');
            checkoutArea.setAttribute('aria-busy', 'true');
          } else {
            if (
              checkoutArea.dataset.compensationWasInert !==
              'true'
            ) {
              checkoutArea.removeAttribute('inert');
            }

            checkoutArea.removeAttribute('aria-busy');
            delete checkoutArea.dataset
              .compensationWasInert;
          }
        });
    }

    updateVisibleNoteFields(note) {
      document
        .querySelectorAll(
          'textarea[name="note"], textarea#Cart-note'
        )
        .forEach((textarea) => {
          textarea.value = note;
        });
    }

    async handleChange() {
      const newValue = this.checkbox.checked;
      const root = window.Shopify?.routes?.root || '/';

      const checkboxes = [
        ...document.querySelectorAll(
          '[data-compensation-checkbox]'
        ),
      ];

      const previousValues = new Map();

      checkboxes.forEach((checkbox) => {
        previousValues.set(
          checkbox,
          checkbox === this.checkbox
            ? !newValue
            : checkbox.checked
        );

        checkbox.checked = newValue;
      });

      document
        .querySelectorAll('[data-compensation-error]')
        .forEach((message) => {
          message.hidden = true;
        });

      this.setBusy(true);

      try {
        const cartResponse = await fetch(`${root}cart.js`, {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
          credentials: 'same-origin',
        });

        if (!cartResponse.ok) {
          throw new Error('Unable to read cart');
        }

        const cart = await cartResponse.json();
        const existingNote = removeCompensationNote(
          cart.note || ''
        );

        const updatedNote = [
          existingNote,
          newValue ? COMPENSATION_NOTE : '',
        ]
          .filter(Boolean)
          .join('\n');

        const updateResponse = await fetch(
          `${root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              attributes: {
                [COMPENSATION_ATTRIBUTE]:
                  newValue ? 'Taip' : '',
              },
              note: updatedNote,
            }),
          }
        );

        if (!updateResponse.ok) {
          throw new Error('Cart update failed');
        }

        await updateResponse.json();
        this.updateVisibleNoteFields(updatedNote);
      } catch (error) {
        previousValues.forEach(
          (previousValue, checkbox) => {
            checkbox.checked = previousValue;
          }
        );

        document
          .querySelectorAll('[data-compensation-error]')
          .forEach((message) => {
            message.hidden = false;
          });

        console.error(error);
      } finally {
        this.setBusy(false);
      }
    }
  }

  customElements.define(
    'cart-compensation-documents',
    CartCompensationDocuments
  );
}